import React, { useState } from "react";

import { BsChevronUp, BsChevronDown } from "react-icons/bs";
import image from "../../assets/images/3.jpg";
const WhatYouGet = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section className="font-lato">
      <h3 className="text-center mb-5 font-playfair font-bold whitespace-nowrap">CREATE YOUR STORY</h3>

      <div className="space-y-4 mt-8">
        <p className=" text-start">Example: Steven Khalil’s Story</p>

        {/* Image container */}
        <div className="relative overflow-hidden mb-6">
          <img
            src={image}
            alt="Story example"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Story content */}
        <p className="space-y-4">
          <span className="animate-fadeIn">
          People often assume I had a perfect upbringing, like I went to private schools or something, but the reality was far from that.{" "}
            {!isExpanded && (
              <p
                className="text-sm cursor-pointer inline-flex items-center"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                ... CONTINUE READING
                {isExpanded ? (
                  <BsChevronUp className="ml-1 w-4 h-4" />
                ) : (
                  <BsChevronDown className="ml-1 w-4 h-4" />
                )}
              </p>
            )}
          </span>

          {isExpanded && (
            <span className="animate-fadeIn leading-relaxed">
            My childhood was tough. My brother had a mental illness, which made life at home chaotic. He would blast music at all hours to drown out the voices in his head. My mum is still his carer. Growing up, I found my escape in creativity. I was drawn to things most kids weren’t, like fabrics and design. I would use old curtains to dress up the little girls in the neighbourhood. I was obsessed with Diana and Charles’ wedding. I was 6 at the time and Mum still remembers how excited I was. She didn’t fully understand, but she never stopped me. She would give me any old fabric she could find, just to let me be creative. We didn’t have much growing up. She was a single parent, and we lived in government housing in Campbelltown. Life was hard, but I was a strong kid, and knowing I would get through it kept me going. You know, my mum did her best. Back then, it was all about survival. If you were fed and clothed, that was success in her eyes. We didn’t talk much about feelings or dreams; it was more about getting through the day. I wanted to study fashion, but I couldn’t get into the fancy design schools. My aunt, a seamstress, said “why don't you go do garment production at Bankstown TAFE”. It wasn’t the prestigious path I had imagined, but it was the right one for me. By 19, I was sewing dresses from my bedroom, and by 21, I became the head designer at a bridal boutique in Double Bay. It felt like destiny, even if it wasn’t the path I initially wanted. I’ve spent my life dressing women for their weddings, always aiming to make them feel special in their gowns. The fabric, the movement, the extravagance—that’s what drew me in. My mum was my biggest cheerleader, always proud of what I achieved. She tells everyone at the supermarket, "Steven Kahlil is my son!" She saw my hard work, even if she didn’t always know how to encourage it. Looking back, I realise nothing in my life was meant to be easy. But I wouldn’t change a thing. It's made me who I am today. I’m grateful for the gift I have, the people around me, and the chance to do what I love.
              {isExpanded && (
                <p
                  className="text-sm cursor-pointer inline-flex items-center"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  ... READ LESS
                  {isExpanded ? (
                    <BsChevronUp className="ml-1 w-4 h-4" />
                  ) : (
                    <BsChevronDown className="ml-1 w-4 h-4" />
                  )}
                </p>
              )}
            </span>
          )}

          {/* Read More/Less Button */}
          {/* <button 
            onClick={() => setIsExpanded(!isExpanded)}
            className="flex items-center gap-2 text-center justify-center mx-auto"
          >
            <span>{isExpanded ? 'READ LESS' : 'READ MORE'}</span>
            {isExpanded ? (
              <BiChevronUp className="w-8 h-8" />
            ) : (
              <BiChevronDown className="w-8 h-8" />
            )}
          </button> */}
        </p>
      </div>
    </section>
  );
};

export default WhatYouGet;
